import { ReactNode, MouseEventHandler } from "react";
import styles from './index.module.scss';

import languageIcon from '../../../assets/icons/language.svg';

type NavProps = {
  children: ReactNode;
  isLanguage?: boolean;
  type?: 'navbar' | 'footer';
  onClick?: MouseEventHandler<HTMLElement>;
  href?: string;
};

export const Nav = (props: NavProps) => {
    const content = (
        <>
            <h4>
                {props.children}
            </h4>
            {props.isLanguage && <img src={languageIcon} alt="Change language" />}
            {props.type === 'footer' &&
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" className={styles.line}>
                    <path d="M0 0.5H1104"/>
                </svg>
            }
        </>
    );

    if (props.href) {
        return (
            <a className={`
                ${styles.nav}
                ${props.isLanguage ? styles.language : ''}
                ${props.type === 'footer' ? styles.footer : ''}
            `} href={props.href}>
                {content}
            </a>
        );
    }
    
    return (
    <nav className={`
        ${styles.nav}
        ${props.isLanguage ? styles.language : ''}
        ${props.type === 'footer' ? styles.footer : ''}
        `} onClick={props.onClick}>
        {content}
    </nav>
    );
};